import React from 'react';
import Button from '../CustomButtons/Button.js';
import { connect } from 'react-redux';
import styles from '../../assets/jss/material-kit-react/views/componentsSections/navbarsStyle.js';
import { makeStyles } from '@material-ui/core/styles';
import budgetplanning from '../../assets/img/categories/budget-planning.png';
import goalsetting from '../../assets/img/categories/goal-setting.png';
import habitplanning from '../../assets/img/categories/habit-planning.png';
import { setCurrentTab } from '../../actions/currentTab';

const useStyles = makeStyles(styles);

function CategoryListing(props) {
  const classes = useStyles();
  let categoryIcon, categoryLabel, hrefLink;
  const { type } = props;

  const setActiveTab = () => {
    props.dispatch(setCurrentTab('goals'));
  };

  switch (type) {
    case 'goal':
      categoryIcon = goalsetting;
      categoryLabel = 'Set or Manage Your Goals';
      hrefLink = 'goals';

      break;
    case 'habit':
      categoryIcon = habitplanning;
      categoryLabel = 'Plan or Manage your Habit Development';
      hrefLink = 'comingsoon';
      break;
    case 'budget':
      categoryIcon = budgetplanning;
      categoryLabel = 'Plan or Manage your Budget';
      hrefLink = 'comingsoon';
      break;
    default:
      categoryIcon = goalsetting;
      categoryLabel = 'Error with retrieving the category';
      break;
  }
  return (
    <div style={{ textAlign: 'center' }}>
      <Button
        href={hrefLink}
        className={classes.navbarLink}
        color='transparent'
        onClick={setActiveTab}
      >
        <div>
          <img
            src={categoryIcon}
            alt='planning category'
            width='300'
            height='300'
          />
          <h2>{categoryLabel}</h2>
        </div>
      </Button>
    </div>
  );
}

export default connect()(CategoryListing);
